<script lang="ts" generics="ROW">
    import type {Readable} from 'svelte/store';
    import type {Table} from '@tanstack/svelte-table';
    import {Render} from 'svelte-render';
    import {exists} from 'shared/utils/custom-utils';
    import {getRenderConfig} from 'shared/ui-widgets/grid/utils';
    import KpGenericGridRow from 'shared/ui-widgets/grid/KpGenericGridRow.svelte';
    import KpGenericGridFooterHeaderCell from 'shared/ui-widgets/grid/grid-cell/KpGenericGridFooterHeaderCell.svelte';

    export let table$: Readable<Table<ROW>>;

    function shouldRenderFooter(tableDef: Table<ROW>) {
        return tableDef.getAllColumns().some((column) => exists(column.columnDef.footer));
    }
</script>

{#if shouldRenderFooter($table$)}
    <div class="kp-generic-grid-footer">
        {#each $table$.getFooterGroups() as footerGroup}
            <KpGenericGridRow>
                {#each footerGroup.headers as header}
                    <KpGenericGridFooterHeaderCell {header}>
                        {#if !header.isPlaceholder}
                            <Render of={getRenderConfig(header.column.columnDef.footer, header.getContext())}/>
                        {/if}
                    </KpGenericGridFooterHeaderCell>
                {/each}
            </KpGenericGridRow>
        {/each}
    </div>
{/if}